"use client"

import { useEffect } from "react"

/**
 * On next load only, bypass SW/page cache by appending a cache-busting query.
 * To trigger: localStorage.setItem('pos-no-cache-next', '1') before navigating/reloading.
 */
export default function OneTimeNoCache() {
  useEffect(() => {
    try {
      const FLAG = 'pos-no-cache-next'
      const val = localStorage.getItem(FLAG)
      if (val === '1') {
        localStorage.removeItem(FLAG)
        const url = new URL(window.location.href)
        url.searchParams.set('_cb', String(Date.now()))
        // Use replace to avoid polluting history
        window.location.replace(url.toString())
      }
    } catch {}
  }, [])
  return null
}

